import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <React.StrictMode>
      <div className="main-page-content">
        <div id="home">
          <div id="particles-js"></div>
          <div className="home-content-main">
            <div className="table-cell">
              <div className="container">
                <div className="row home-row">
                  <div className="col-md-12 col-sm-12">
                    <div className="home-text wow fadeIn text-center">
                       <h1 className="cd-headline clip is-full-width">
                        <span
                          className="cd-words-wrapper"
                          style={{ 
                            width: "266px", 
                            overflow: "hidden",
                            color: "#fff",
                            fontWeight: "bold" 
                          }}
                        >
                          <b className="is-visible">Yves KOKOU</b>
                          <b className="is-hidden">Développeur</b>
                          <b className="is-hidden">Full stack</b>
                        </span>
                      </h1>
                      <div className="about-social-icon text-center">
                        <ul className="about-social">
                          <li className="wow fadeIn" data-wow-delay=".6s">
                            <a
                              href="https://www.linkedin.com/in/yves-kokou-35a72923b/"
                              target="newtab"
                            >
                              <i
                                className="fa fa-linkedin"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                          <li className="wow fadeIn" data-wow-delay=".2s">
                            <a
                              href="https://www.facebook.com/yves.kokou.98"
                              target="newtab"
                            >
                              <i
                                className="fa fa-facebook"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                          <li className="wow fadeIn" data-wow-delay=".4s">
                            <a
                              href="https://www.instagram.com/yves_tepe/"
                              target="newtab"
                            >
                              <i
                                className="fa fa-instagram"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                          <li className="wow fadeIn" data-wow-delay="1.2s">
                            <a href="https://github.com/Yveskk" target="newtab">
                              <i
                                className="fa fa-github"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="parallax" data-velocity="-.1"></div>
          <div className="parallax" data-velocity="-.5" data-fit="525"></div>
        </div>

        {/* <!-- ================================ ABOUT =============================== --> */}

        <div id="about">
          <div className="about-content">
            <div className="love-grid text-center">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-title text-center wow fadeIn">
                      <h3>Profil & Expertise</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p className="text-justify">
                        Ingénieur Logiciel et Développeur Full Stack Senior, je
                        conçois des solutions numériques performantes,
                        sécurisées et scalables. Fort d'une expérience
                        internationale, je maîtrise l'intégralité de la chaîne
                        technique pour transformer vos défis complexes en
                        produits robustes et innovants.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="about-back"></div>
            <div className="me-grid">
              <div className="container">
                <div className="row">
                  <div className="col-md-4 col-sm-6 col-xs-12 about-col">
                    <div className="about-image">
                      <img
                        src="assets/img/about-image.jpg"
                        alt="Yves KOKOU"
                        className="about-img wow fadeIn"
                      />
                    </div>
                  </div>
                  <div className="col-md-8 col-sm-6 col-xs-12 about-col">
                    <div className="about-details wow fadeIn">
                      <div className="main-title left-title text-left wow fadeIn">
                        <h3>Parcours & Engagement</h3>
                        <div className="underline1 no-margin"></div>
                        <div className="underline2 no-margin"></div>
                      </div>
                      <p className="wow fadeIn text-justify">
                        Passionné par l'ingénierie logicielle, j'ai forgé mon
                        expertise au sein d'équipes innovantes chez NOLIHA,
                        WoeLabs, SC Innovations et Trankyl. Actuellement
                        Ingénieur Logiciel chez HIPSWCA, je me spécialise dans
                        la conception de solutions Full-Stack performantes et
                        évolutives. Mon parcours reflète une progression
                        constante et un engagement fort vers la qualité
                        technique et l'innovation produit.
                      </p>
                      <a
                        className="about-link-1"
                        href="assets/cv/Resume -CV-Yves.docx.pdf"
                        target="_blank"
                      >
                        Mon CV
                      </a>
                      {/* <a className="about-link-2" href="#contact">
                        Hire Me
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


     
        {/* <!-- ================================ Skill =============================== --> */}

        <div id="skill">
          <div className="skill-main">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="main-title text-center wow fadeIn">
                    <h3>Mes compétences</h3>
                    <div className="underline1"></div>
                    <div className="underline2"></div>
                    <p className="text-justify">
                      J'apprécie une structure de contenu simple, des modèles de
                      conception épurés, et des interactions réfléchies.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row love-row wow fadeIn">
                <div className="col-md-4 col-sm-6">
                  <div className="skill-card">
                    <div className="skill-icon-wrapper">
                      <i className="fa fa-code"></i>
                    </div>
                    <h3>JavaScript && TypeScript</h3>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="skill-card">
                    <div className="skill-icon-wrapper">
                      <i className="fa fa-mobile"></i>
                    </div>
                    <h3>React JS && React Native</h3>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="skill-card">
                    <div className="skill-icon-wrapper">
                      <i className="fa fa-server"></i>
                    </div>
                    <h3>Node JS && Nest JS</h3>
                  </div>
                </div>
              </div>

              <div className="row love-row wow fadeIn" style={{ marginTop: "20px" }}>
                <div className="col-md-4 col-sm-6">
                  <div className="skill-card">
                    <div className="skill-icon-wrapper">
                      <i className="fa fa-database"></i>
                    </div>
                    <h3>MySQL, PostgreSQL && MongoDB</h3>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="skill-card">
                    <div className="skill-icon-wrapper">
                      <i className="fa fa-cubes"></i>
                    </div>
                    <h3>Docker, Firebase, Git && AWS</h3>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="skill-card">
                    <div className="skill-icon-wrapper">
                      <i className="fa fa-cog"></i>
                    </div>
                    <h3>Rust</h3>
                  </div>
                </div>
              </div>

              <div className="row love-row wow fadeIn" style={{ marginTop: "20px" }}>
                <div className="col-md-4 col-sm-6">
                  <div className="skill-card">
                    <div className="skill-icon-wrapper">
                      <i className="fa fa-code"></i>
                    </div>
                    <h3>Angular</h3>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="skill-card">
                    <div className="skill-icon-wrapper">
                      <i className="fa fa-cloud"></i>
                    </div>
                    <h3>Google Cloud</h3>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="skill-card">
                    <div className="skill-icon-wrapper">
                      <i className="fa fa-paint-brush"></i>
                    </div>
                    <h3>Figma && Canva</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
 {/* <!-- ============================================== SERVICE ===================================================== --> */}

        <div id="service">
          <div className="service-content">
            <div className="service-grid text-center">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-title text-center wow fadeIn">
                      <h3>Projets Réalisés</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        J'ai eu l'opportunité de contribuer à plusieurs projets
                        innovants en tant que développeur Full-Stack, avec un
                        accent particulier sur la collaboration et
                        l'optimisation des fonctionnalités tant sur le back-end
                        que le front-end.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="row love-row wow fadeIn">
                  <div className="col-md-4 col-sm-6">
                    <div className="service-details" data-wow-delay=".1s">
                      <div className="service-head">
                        <img
                          src="assets/img/service/design-development.jpg"
                          alt="Safe SOS"
                        />
                      </div>
                      <div className="service-bottom">
                        <h3>Safe SOS</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p className="text-justify">
                          Solution de sécurité innovante permettant l'envoi
                          d'alertes d'urgence instantanées et une gestion
                          optimisée des secours par les autorités compétentes.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <div className="service-details" data-wow-delay=".1s">
                      <div className="service-head">
                        <img
                          src="assets/img/service/5.png"
                          alt="PHOENIX-UEMOA"
                        />
                      </div>
                      <div className="service-bottom">
                        <h3>PHOENIX-UEMOA</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p className="text-justify">
                          Plateforme de gestion et de suivi stratégique pour la
                          région UEMOA, facilitant la collaboration et la
                          centralisation des données institutionnelles.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <div className="service-details" data-wow-delay=".1s">
                      <div className="service-head">
                        <img
                          src="assets/img/service/analytics.jpg"
                          alt="Voyager Simple"
                        />
                      </div>
                      <div className="service-bottom">
                        <h3>Voyager Simple</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p className="text-justify">
                          Plateforme intuitive dédiée à la planification et à la
                          réservation de voyages, simplifiant l'expérience
                          utilisateur pour les voyageurs.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row" style={{ marginTop: "40px", textAlign: "center" }}>
                  <div className="col-md-12">
                    <Link
                      to="/projects"
                      className="about-link-1"
                      style={{ 
                        background: "#005C63", 
                        borderColor: "#005C63", 
                        color: "#fff",
                        display: "inline-block",
                        padding: "12px 30px",
                        textDecoration: "none"
                      }}
                    >
                      Voir tous les projets
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonial">
              <div className="testimonial-content">
                <div className="testimonial-grid">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="main-title text-center wow fadeIn">
                          <h3>Témoignages</h3>
                          <div className="underline1"></div>
                          <div className="underline2"></div>
                          <p>
                            Les témoignages de mes collaborateurs sont élogieux.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-details">
                    <section id="carousel">
                      <div className="container">
                        <div className="row">
                          <div className="col-md-8 col-md-offset-2">
                            <div className="quote">
                              <i className="fa fa-quote-left fa-4x"></i>
                            </div>
                            <div
                              className="carousel slide"
                              id="fade-quote-carousel"
                              data-ride="carousel"
                              data-interval="10000"
                            >
                              <ol className="carousel-indicators">
                                <li
                                  data-target="#fade-quote-carousel"
                                  data-slide-to="0"
                                  className="active"
                                ></li>
                                <li
                                  data-target="#fade-quote-carousel"
                                  data-slide-to="1"
                                ></li>
                              </ol>
                              <div className="carousel-inner">
                                <div className="active item">
                                  <blockquote>
                                    <p className="text-justify">
                                      "Yves est un développeur dévoué. J’ai eu à
                                      travailler avec lui sur un projet et j’ai
                                      été impressionné par ses qualités
                                      techniques et professionnelles."
                                    </p>
                                    <span style={{ fontSize: "1.2em" }}>
                                      <a
                                        href="https://www.linkedin.com/in/mathias-kodjo-agbayi-495a524a/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Mathias Kodjo Agbayi
                                      </a>
                                      , Software Developer at Upgrade, Inc
                                    </span>
                                  </blockquote>
                                </div>

                                <div className="item">
                                  <blockquote>
                                    <p className="text-justify">
                                      "Yves est un développeur qui aime apporter
                                      et partager ces connaissances avec ces
                                      collègues et aime travailler en équipe. Il
                                      aime toujours cherche à trouver des
                                      solutions à tous problèmes liés au code."
                                      <br />
                                    </p>
                                    <span>PALOU Arlette</span>
                                  </blockquote>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* <!-- ================================ RESUME =============================== --> */}

        <div id="resume">
          <div className="resume-content">
            <div className="resume-grid text-center">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-title text-center wow fadeIn">
                      <h3>Historique éducative</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                    </div>
                  </div>
                </div>
                <div className="row love-row wow fadeIn">
                  <div className="col-md-4 col-sm-4">
                    <div className="resume-details" data-wow-delay=".2s">
                      <div className="resume-hover"></div>
                      <div className="resume-main">
                        <i
                          className="fa fa-home resume-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Lycée</h3>
                        <h2>2020</h2>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p className="text-justify">
                          Obtention d'un Baccalauréat scientifique au Lycée
                          Sanguera, marquant le début de mon parcours
                          d'excellence technique.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div className="resume-details" data-wow-delay=".3s">
                      <div className="resume-hover"></div>
                      <div className="resume-main">
                        <i
                          className="fa fa-graduation-cap resume-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Université</h3>
                        <h2>2020-2023</h2>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p className="text-justify">
                          Diplômé d'une Licence en Génie Logiciel à l'UCAO-UUT.
                          Spécialisation en architecture applicative et
                          développement full-stack.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div className="resume-details" data-wow-delay=".4s">
                      <div className="resume-hover"></div>
                      <div className="resume-main">
                        <i
                          className="fa fa-graduation-cap resume-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Expérience</h3>
                        <h2>2023-2026</h2>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p className="text-justify">
                          Parcours de développeur Full-Stack chez SC Innovations
                          et Trankyl, menant à mon poste actuel d'Ingénieur
                          Logiciel chez HIPSWCA.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

       
        <div id="contact">
                <div className="container">
                  <div className="row contact-info-row text-center wow fadeIn">
                    <div className="col-md-3 col-sm-6 contact-colamn">
                      <div className="contact-col-info" data-wow-delay=".2s">
                        <i
                          className="fa fa-map-marker contact-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Addresse</h3>
                        <p>Lomé, Togo</p>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6 contact-colamn">
                      <div className="contact-col-info" data-wow-delay=".4s">
                        <a
                          href="yves.kokou.10@gmail.com"
                          style={{
                            color: "black",
                            textDecoration: "none",
                            fontSize: "17px",
                          }}
                        >
                          <i
                            className="fa fa-envelope contact-icon"
                            aria-hidden="true"
                          ></i>
                          <h3> Email</h3>
                          yves.kokou.10@gmail.com
                        </a>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6 contact-colamn">
                      <div className="contact-col-info" data-wow-delay=".6s">
                        <i
                          className="fa fa-mobile contact-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Téléphone</h3>
                        <a
                          href="tel:+22896529200"
                          style={{
                            color: "black",
                            textDecoration: "none",
                            fontSize: "17px",
                          }}
                        >
                          +228 96529200
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
        </div>
      </div>
    </React.StrictMode>
  );
};

export default Home;
